import React, { useContext, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import db, { auth } from "../../Firebase/config";
import firebase from "firebase/compat/app";
import { doc, getDoc, setDoc, Timestamp } from "firebase/firestore";
import "./complaint.css";
import { AuthContext } from "../../Context/UseAuthContext";
import SideNav from "../SideNav/SideNav";
import Navbar from "../Navbar/Navbar";

const Complaint = () => {
  const [form, setForm] = useState({
    complaintType: "",
    location: "",
    categorie: "",
    complaintMessage: "",
    id: Math.random().toString(),
  });
  const [user, setUser] = useState();

  const { complaintType, location, categorie, complaintMessage, id } = form;

  // const { user } = useContext(AuthContext);

  const changeHandler = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    getDoc(doc(db, "users", auth.currentUser.uid)).then((docSnap) => {
      if (docSnap.exists()) {
        setUser(docSnap.data());
      } else {
        return "collection doesnt exist";
      }
    });

    const username = user?.name;

    setDoc(doc(db, "complaints", id), {
      complaintType,
      location,
      categorie,
      complaintMessage,
      timestamp: Timestamp.fromDate(new Date()),
      username,
      id,
    });

    setForm({
      complaintType: "",
      categorie: "",
      complaintMessage: "",
    });
  };

  return (
    <div className="app">
      <div className="app-left">
        <SideNav />
      </div>
      <div className="app-right">
        <Navbar />
        <div className="complaint">
          <div className="complaint-body">
            <h2>Make a Complaint</h2>
            <div className="complaints-form">
              <Form onSubmit={handleSubmit}>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Select type of complaint</Form.Label>
                  <Form.Select
                    name="complaintType"
                    value={complaintType}
                    onChange={changeHandler}
                    aria-label="Default select example"
                  >
                    <option>Open this select menu</option>
                    <option value="Social Complaint">Social Complaint</option>
                    <option value="Personal Complaint">
                      Personal Complaint
                    </option>
                  </Form.Select>
                </Form.Group>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Location</Form.Label>
                  <Form.Select
                    name="location"
                    value={location}
                    onChange={changeHandler}
                    aria-label="Default select example"
                  >
                    <option value="Ayawaso West">Ayawaso West</option>
                    <option value="Other">Other</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Category</Form.Label>
                  <Form.Select
                    name="categorie"
                    value={categorie}
                    onChange={changeHandler}
                    aria-label="Default select example"
                  >
                    <option>Select Category...</option>
                    <option value="Sanitation">Sanitation</option>
                    <option value="Utilities">Utilities</option>
                    <option value="Construction">Construction</option>
                    <option value="Work">Work</option>
                    <option value="Health">Health</option>
                    <option value="Market">Market</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Label>Type Complaint</Form.Label>
                  <Form.Control
                    name="complaintMessage"
                    value={complaintMessage}
                    onChange={changeHandler}
                    as="textarea"
                    rows={5}
                  />
                </Form.Group>
                <Button variant="success" type="submit">
                  Submit Complaint
                </Button>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Complaint;
